import * as z from 'zod';

export const emailSearchCustomerSchema = z.object({
  id: z.string(),
  givenName: z.string().optional(),
  familyName: z.string().optional(),
  emailAddress: z.string().optional(),
  phoneNumber: z.string().optional(),
  accountType: z.string().optional(),
});

export type EmailSearchCustomer = z.infer<typeof emailSearchCustomerSchema>;

export const findCustomersByEmailAddressResponseSchema = z.object({
  customers: z.array(emailSearchCustomerSchema).optional(),
});

export type FindCustomersByEmailAddressResponse = z.infer<typeof findCustomersByEmailAddressResponseSchema>;
